import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_For_more_informationX_please_v_ELL_3,
  TXTWCL_You_can_still_make_withdrawals_ELL,
  TXTWCL_Your_account_has_been_suspende_ELL_4
} from './NationalExclusion.messages.json';

const NationalExclusion: React.FC = () => (
  <>
    <Translation tagName="span" {...TXTWCL_Your_account_has_been_suspende_ELL_4} />
    <Translation tagName="p" {...TXTWCL_You_can_still_make_withdrawals_ELL} />
    <Translation
      tagName="p"
      {...TXTWCL_For_more_informationX_please_v_ELL_3}
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.RgiajDepositWithdraw}>{msg}</ResolverLink>
        )
      }}
    />
  </>
);

export default NationalExclusion;
